import PermIdentity from '@material-ui/icons/PermIdentity';
import {BlogArticleCreate} from "./BlogArticleCreate";
import {BlogArticleEdit} from "./BlogArticleEdit";
import {BlogArticleList} from "./BlogArticleList";


// import {
//     ShowGuesser,
//     // EditGuesser
// } from 'react-admin';


// import {BaseListIdNameEdit} from "./BaseListIdNameEdit";
// import {BaseListIdNameCreate} from "./BaseListIdNameCreate";

const resource = {
    list: BlogArticleList,
    create: BlogArticleCreate,
    edit: BlogArticleEdit,
    // show: ShowGuesser,
    icon: PermIdentity,
};

export default resource;